var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"bg-gray breadcrumb-container py-2 px-3",attrs:{"fluid":""}},[_c('b-container',[_c('b-breadcrumb',{attrs:{"items":_vm.breadcrumbsList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }